// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.promoted-input-checkbox {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.promoted-checkbox {
  margin-right: 20px;
  margin-left: 2px;
}
.promoted-checkbox input:checked + label > img {
  height: 24px;
}
.promoted-checkbox input:checked + label span.text {
  color: var(--gold-light);
  opacity: 0.95;
}
.promoted-checkbox label {
  line-height: 40px;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: row;
  transition: opacity 0.15s ease;
}
.promoted-checkbox label:hover span.text {
  opacity: 1;
}
.promoted-checkbox label:focus-within {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
  border-radius: 4px;
}
.promoted-checkbox label span {
  margin: auto 10px;
}
.promoted-checkbox label:after {
  content: "";
  float: left;
  border-radius: 3px;
  transition: 0.15s all ease-out;
}
.promoted-checkbox img {
  width: 24px;
  height: 24px;
  margin: auto 0;
  transition: filter 0.15s ease;
}`, "",{"version":3,"sources":["webpack://./src/constructorComponents/chat/checkbox/styles.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AACJ;;AAEA;EACI,kBAAA;EACA,gBAAA;AACJ;AAAI;EAEI,YAAA;AACR;AAOQ;EACI,wBAAA;EACA,aAAA;AALZ;AASI;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAPR;AASQ;EACI,UAAA;AAPZ;AAUQ;EAAiB,oCAAA;EAAsC,mBAAA;EAAqB,kBAAA;AALpF;AAOQ;EACI,iBAAA;AALZ;AAQQ;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;AANZ;AAUI;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,6BAAA;AARR","sourcesContent":[".promoted-input-checkbox {\r\n    border: 0;\r\n    clip: rect(0 0 0 0);\r\n    height: 1px;\r\n    margin: -1px;\r\n    overflow: hidden;\r\n    padding: 0;\r\n    position: absolute;\r\n    width: 1px;\r\n}\r\n\r\n.promoted-checkbox {\r\n    margin-right: 20px;\r\n    margin-left: 2px;\r\n    input:checked+label>img {\r\n        // Firefox doesn't render svg's that is loading with the use tag if its been set to display: none and then toggled to display: block, so you have to use tricks like this to get it to render again:\r\n        height: 24px;\r\n    }\r\n    // The icon asset stays a flat checkbox_checked.svg; the label picks up\r\n    // the accent to confirm the toggle is on.\r\n    input:checked+label {\r\n        img {\r\n            \r\n        }\r\n        span.text {\r\n            color: var(--gold-light);\r\n            opacity: 0.95;\r\n        }\r\n    }\r\n\r\n    label {\r\n        line-height: 40px;\r\n        cursor: pointer;\r\n        position: relative;\r\n        display: flex;\r\n        flex-direction: row;\r\n        transition: opacity 0.15s ease;\r\n\r\n        &:hover span.text {\r\n            opacity: 1;\r\n        }\r\n\r\n        &:focus-within { outline: 2px solid var(--gold-light); outline-offset: 2px; border-radius: 4px; }\r\n\r\n        span {\r\n            margin: auto 10px;\r\n        }\r\n\r\n        &:after {\r\n            content: \"\";\r\n            float: left;\r\n            border-radius: 3px;\r\n            transition: 0.15s all ease-out;\r\n        }\r\n    }\r\n\r\n    img {\r\n        width: 24px;\r\n        height: 24px;\r\n        margin: auto 0;\r\n        transition: filter 0.15s ease;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
